export default "<p>\r\n  layouts works!\r\n</p>\r\n";